export const verificarNaturalezaSeleccionada = (numbers, listaTipoAccion) => {
    return listaTipoAccion?.flat().some(number => numbers.includes(parseInt(number)));
}